import { API } from 'aws-amplify'

const PROVISION_ENDPOINT_NAME = 'ProvisionAPI'

API.configure({
  endpoints: [
    {
      name: PROVISION_ENDPOINT_NAME,
      endpoint: process.env.REACT_APP_PROVISION_API,
      region: process.env.REACT_APP_AWS_REGION,
    },
  ],
})

const provisioningService = {
  getCustomerProvisions: async (customerId, customerCode) =>
    await API.get(PROVISION_ENDPOINT_NAME, `/provisions/${customerId}/${customerCode}`, {}),
  createCustomerProvision: async (customerSAPID, customerCode) =>
    await API.post(
      PROVISION_ENDPOINT_NAME,
      `/provisions/${customerSAPID}/${customerCode}/provision`,
      {
        body: {},
      },
    ),
}
export default provisioningService
